export default __webpack_public_path__ + "static/media/fa.bundle.42862f33.svg";